import React, {useEffect, useState} from 'react';
import {
  FormOperacionCapitalMarketsDetalle,
  OperacionCapitalMarketsDetalle,
  schemaOperacionCapitalMarketsDetalle
} from "../types/types";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod/dist/zod";
import {useDetalle} from "../hooks/useDetalle";
import {Button} from "@mui/material";
import {ICON_MAS} from "../../../components/SharedIcons";
import CardActions from "../../../components/CardActions";
import CapitalMarketsDetalle from "./CapitalMarketsDetalle";
import CapitalMarketsDetalleDialog from "./CapitalMarketsDetalleDialog";
import {HttpCapitalMarkets} from "../api/httpCapitalMarkets";
import toast from "react-hot-toast";

interface SeccionCapitalMarketsDetalleProps {
  codPais: number,
  operacionId: number,
  permiteEditar: boolean,
}

function SeccionCapitalMarketsDetalle({codPais, operacionId, permiteEditar}: SeccionCapitalMarketsDetalleProps) {
  const [openDialog, setOpenDialog] = useState<boolean>(false)

  const {detalle, status, refetch} = useDetalle(operacionId)

  const formMethods = useForm<FormOperacionCapitalMarketsDetalle>({
    resolver: zodResolver(schemaOperacionCapitalMarketsDetalle),

  })

  useEffect(() => {
    if (detalle) {
      formMethods.reset({...detalle})
    }
  }, [detalle, formMethods]);

  const alGuardarDetalle = (data: FormOperacionCapitalMarketsDetalle) => {
    const promise = HttpCapitalMarkets.putDetalle(operacionId, data.id, data)

    toast
      .promise(promise, {
        loading: 'Guardando',
        success: 'Guardado correctamente',
        error: 'Error al guardar'
      })
      .then(() => {
        refetch()
        setOpenDialog(false)
      })
  }

  return (
    <CardActions
      title={'Detalle'}

      actions={
        permiteEditar &&
          <Button variant='contained' color='primary' endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
              Editar
          </Button>
      }

      colapsable
    >
      {
        detalle &&
          <CapitalMarketsDetalle detalle={detalle}/>

      }
      {
        detalle
        &&
          <CapitalMarketsDetalleDialog
              codPais={codPais}
              formMethods={formMethods}
              open={openDialog}
              detalle={detalle}
              onClose={() => setOpenDialog(false)} onSubmitForm={alGuardarDetalle}/>
      }
    </CardActions>
  );
}

export default SeccionCapitalMarketsDetalle;